import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Scale, Loader2, ArrowLeft, Mail, KeyRound } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { API } from "../config/api";


export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Te rugăm să introduci adresa de email");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${API}/auth/forgot-password`, { email });
      setEmailSent(true);
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response?.data?.detail || "A apărut o eroare");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center login-bg relative">
      <div className="absolute inset-0 bg-primary/70 backdrop-blur-sm" />
      
      <Card className="w-full max-w-md mx-4 relative z-10 shadow-2xl border-0" data-testid="forgot-password-card">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-16 h-16 bg-primary rounded-full flex items-center justify-center mb-4">
            <Scale className="w-8 h-8 text-primary-foreground" />
          </div>
          <CardTitle className="font-heading text-2xl">Recuperare Parolă</CardTitle>
          <CardDescription className="font-body text-muted-foreground">
            {emailSent 
              ? "Verifică email-ul pentru parola temporară"
              : "Introdu adresa de email pentru a primi o parolă temporară"
            }
          </CardDescription>
        </CardHeader>
        
        <CardContent>
          {emailSent ? (
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <KeyRound className="w-8 h-8 text-green-600" />
              </div>
              <p className="font-body text-sm text-muted-foreground">
                O parolă temporară a fost trimisă la adresa <strong>{email}</strong>.
              </p>
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-left">
                <p className="font-body text-sm text-amber-800">
                  <strong>Instrucțiuni:</strong>
                </p>
                <ol className="font-body text-sm text-amber-700 mt-2 space-y-1 list-decimal list-inside">
                  <li>Verifică email-ul pentru parola temporară</li>
                  <li>Autentifică-te cu parola temporară</li>
                  <li>Setează o parolă nouă când ți se va cere</li>
                </ol>
              </div>
              <Link to="/login">
                <Button className="w-full font-body mt-4">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Mergi la Login
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email" className="font-body text-sm font-medium">
                  Email
                </Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="Introdu adresa de email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="font-body"
                  data-testid="forgot-email-input"
                />
              </div>
              
              <Button
                type="submit"
                className="w-full font-body font-medium"
                disabled={isLoading}
                data-testid="forgot-submit-button"
              >
                {isLoading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Se trimite...
                  </>
                ) : (
                  <>
                    <Mail className="mr-2 h-4 w-4" />
                    Trimite Parolă Temporară
                  </>
                )}
              </Button>
              
              <Link to="/login" className="block">
                <Button variant="ghost" className="w-full font-body text-sm">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Înapoi la Login
                </Button>
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
